export default __webpack_public_path__ + "static/media/tick_icon.71c92979.svg";